// import SETUP_WIZARDS_STEPS, { SETUP_WIZARDS } from '@/constants/setup-wizards'
// import store from '@/store'
// import { PACKAGE_PERMISSIONS } from '@/constants/features'
// import USER_TYPES from '@/constants/authorization/user-types'

export default [
  // {
  //   title: 'design.design',
  //   icon: 'Edit2Icon',
  //   children: [
  //     {
  //       title: 'design.qr.qr-menu-themes',
  //       wizard: SETUP_WIZARDS.DESIGN_QR,
  //       route: 'admin:design:qr',
  //       tag: 'upgrade',
  //       tagPackagePermission: PACKAGE_PERMISSIONS.QR_CUSTOMIZATION,
  //       stepsNames: SETUP_WIZARDS_STEPS[SETUP_WIZARDS.DESIGN_QR]?.stepsNames ?? [],
  //     },
  //     {
  //       title: 'design.tablet.ipad-menu-themes',
  //       wizard: SETUP_WIZARDS.DESIGN_TABLET,
  //       tag: 'upgrade',
  //       tagPackagePermission: PACKAGE_PERMISSIONS.IPAD,
  //       route: 'admin:design:tablet',
  //       stepsNames: SETUP_WIZARDS_STEPS[SETUP_WIZARDS.DESIGN_TABLET]?.stepsNames ?? [],
  //       hide: () => store.getters['subscription/isQr'],
  //     },
  //     {
  //       title: 'design.receipt-settings',
  //       icon: 'CheckIcon',
  //       route: 'admin:design:receipt-setting',
  //       userTypes: [USER_TYPES.BRANCH_ADMIN],
  //     },
  //     {
  //       title: 'design.mobile.themes',
  //       route: 'admin:design:mobile',
  //       icon: 'CheckIcon',
  //       hide: () => !store.getters['subscription/isMobileAppPurchased'],
  //     },
  //   ],
  // },
]
